import isEmail from 'validator/lib/isEmail';

export const validate = ({ name, email }) => {
    const errors = {};
    if (!name) {
        errors.name = 'Du må legge inn navn';
    }

    if (!email) {
        errors.email = 'Du må legge inn e-postadresse';
    } else if (!isEmail(email)) {
        errors.email = 'Du må legge inn en gyldig e-postadresse';
    }

    return errors;
};
